<section class="main-note-view">
  <alert-message [alert]="alert"></alert-message>
  <h2 class="main-note-view__header">
    <img-lazy-loading
      class="main-note-view__header__thumbnail-img"
      *ngIf="note && note.thumbnails && note.thumbnailImage"
      [mainThumb]="note.thumbnailImage"
      [thumbs]="note.thumbnails"
      [title]="'Read more about ' + note.name"></img-lazy-loading>
    <span class="main-note-view__header__title"
      [title]="note.name">{{note.name}}</span>
  </h2>
  <div class="main-note-view__tags" *ngIf="noteTags.length > 0">
    <a
        [routerLink]="['/search/query/notes', tag.code]"
        class="main-note-view__tags__tag" title="{{tag.label}}" *ngFor="let tag of noteTags">{{tag.label}}</a>
  </div>
  <div class="main-note-view__writer" *ngIf="note && note.user">
    <div class="main-note-view__writer__wrapper">
      <a
        class="by-user"
        [routerLink]="['/user', note.user.userName || note.userId, 'profile']"
        [title]="'Visit ' + (note.user.displayName || note.user.userDisplayName) + ' profile!'">
        <img-lazy-loading
          class="avatar"
          *ngIf="note.user && note.user.profileImageUrl" [src]="note.user.profileImageUrl"
          [mainThumb]="note.user.profileImageUrl"
          [thumbs]="note.user.profileImgThbs"></img-lazy-loading>
        {{note.user.displayName ? note.user.displayName : note.user.userDisplayName}}
      </a>
      <span class="text-in">in</span>
      <a
        *ngIf="note && note.stream"
        class="stream"
        [title]="'Visit ' + note.stream.name + ' stream!'"
        [routerLink]="(note.stream && note.stream.shortURLPath) ? ['/s', note.stream.shortURLPath] : ['/streams', note.channelId, 'view', note.stream.indexedName || note.stream.name || note.stream.id]">
        {{note.stream.name}}
      </a>
      <span class="date">{{note.published || note.created | date: 'MMM dd, yyyy' }}</span>
    </div>
    <div class="main-note-view__writer__other">
      <a
        [routerLink]="['/note', note.id]"
        *ngIf="isNoteOwner || isUserAdmin"
        class="notd__button--v2 user--buttons"
        title="Edit your note">
        Edit
      </a>
      <a
        (click)="deleteNote()"
        noDblClick
        *ngIf="canDeleteNote"
        class="notd__button--v2 user--buttons"
        title="Delete this note">
        Delete
      </a>
      <svg
        *ngIf="note.pinned"
        class="pinned--note"
        enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg"><g><path d="m330.274 0-10.607 10.607c-24.914 24.914-28.585 63.132-11.047 91.987l-107.305 72.504-1.856-1.856c-40.939-40.939-107.553-40.94-148.492 0l-10.607 10.606 133.289 133.289-173.649 173.65 21.213 21.213 173.649-173.65 133.29 133.29 10.607-10.607c40.94-40.94 40.939-107.553 0-148.492l-1.856-1.856 72.504-107.305c28.855 17.539 67.073 13.868 91.987-11.047l10.606-10.606zm-3.187 428.148-243.235-243.235c29.104-19.248 68.783-16.069 94.394 9.541l139.3 139.3c25.61 25.611 28.789 65.29 9.541 94.394zm-11.791-139.07-92.374-92.374 105.496-71.281 58.159 58.159zm101.245-117.958-75.66-75.66c-13.828-13.828-16.758-34.491-8.789-51.216l135.665 135.665c-16.725 7.969-37.388 5.039-51.216-8.789z"/></g></svg>
      <button
        class="user-link--button"
        [routerLink]="['/user', note.user.userName || note.userId, 'profile']"
        title="Visit user stream.">
        <img
          class="avatar"
          *ngIf="note.user && note.user.profileImageUrl" [src]="note.user.profileImageUrl" />
        Visit owner profile
      </button>
      <button
        *ngIf="note.stream"
        class="stream-link--button"
        [routerLink]="note.stream.shortURLPath ? ['/s', note.stream.shortURLPath] : ['/streams', note.channelId, 'view', note.stream.indexedName || note.stream.name || note.stream.id]"
        title="Visit user stream.">
        <fa-icon [icon]="['fas', 'stream']"></fa-icon>
        Visit stream
      </button>
      <button
        class="share--button"
        (click)="openSocialModal()"
        title="Share link with your frieds.">
        <svg height="512pt" viewBox="-21 0 512 512" width="512pt" xmlns="http://www.w3.org/2000/svg"><path d="m453.332031 85.332031c0 38.292969-31.039062 69.335938-69.332031 69.335938s-69.332031-31.042969-69.332031-69.335938c0-38.289062 31.039062-69.332031 69.332031-69.332031s69.332031 31.042969 69.332031 69.332031zm0 0"/><path d="m384 170.667969c-47.0625 0-85.332031-38.273438-85.332031-85.335938 0-47.058593 38.269531-85.332031 85.332031-85.332031s85.332031 38.273438 85.332031 85.332031c0 47.0625-38.269531 85.335938-85.332031 85.335938zm0-138.667969c-29.417969 0-53.332031 23.9375-53.332031 53.332031 0 29.398438 23.914062 53.335938 53.332031 53.335938s53.332031-23.9375 53.332031-53.335938c0-29.394531-23.914062-53.332031-53.332031-53.332031zm0 0"/><path d="m453.332031 426.667969c0 38.289062-31.039062 69.332031-69.332031 69.332031s-69.332031-31.042969-69.332031-69.332031c0-38.292969 31.039062-69.335938 69.332031-69.335938s69.332031 31.042969 69.332031 69.335938zm0 0"/><path d="m384 512c-47.0625 0-85.332031-38.273438-85.332031-85.332031 0-47.0625 38.269531-85.335938 85.332031-85.335938s85.332031 38.273438 85.332031 85.335938c0 47.058593-38.269531 85.332031-85.332031 85.332031zm0-138.667969c-29.417969 0-53.332031 23.9375-53.332031 53.335938 0 29.394531 23.914062 53.332031 53.332031 53.332031s53.332031-23.9375 53.332031-53.332031c0-29.398438-23.914062-53.335938-53.332031-53.335938zm0 0"/><path d="m154.667969 256c0 38.292969-31.042969 69.332031-69.335938 69.332031-38.289062 0-69.332031-31.039062-69.332031-69.332031s31.042969-69.332031 69.332031-69.332031c38.292969 0 69.335938 31.039062 69.335938 69.332031zm0 0"/><path d="m85.332031 341.332031c-47.058593 0-85.332031-38.269531-85.332031-85.332031s38.273438-85.332031 85.332031-85.332031c47.0625 0 85.335938 38.269531 85.335938 85.332031s-38.273438 85.332031-85.335938 85.332031zm0-138.664062c-29.417969 0-53.332031 23.933593-53.332031 53.332031s23.914062 53.332031 53.332031 53.332031c29.421875 0 53.335938-23.933593 53.335938-53.332031s-23.914063-53.332031-53.335938-53.332031zm0 0"/><path d="m135.703125 245.761719c-7.425781 0-14.636719-3.863281-18.5625-10.773438-5.824219-10.21875-2.238281-23.253906 7.980469-29.101562l197.949218-112.851563c10.21875-5.867187 23.253907-2.28125 29.101563 7.976563 5.824219 10.21875 2.238281 23.253906-7.980469 29.101562l-197.953125 112.851563c-3.328125 1.898437-6.953125 2.796875-10.535156 2.796875zm0 0"/><path d="m333.632812 421.761719c-3.585937 0-7.210937-.898438-10.539062-2.796875l-197.953125-112.851563c-10.21875-5.824219-13.800781-18.859375-7.976563-29.101562 5.800782-10.238281 18.855469-13.84375 29.097657-7.976563l197.953125 112.851563c10.21875 5.824219 13.800781 18.859375 7.976562 29.101562-3.945312 6.910157-11.15625 10.773438-18.558594 10.773438zm0 0"/></svg>
        Share
        <social-sharing [note]="note"></social-sharing>
      </button>
      <a
        *ngIf="!isNoteOwner && isLoggedIn"
        (click)="toggleBookmark()"
        [title]="'Bookmark this note!'"
        class="bookmark--button">
        <svg *ngIf="!isBookmarked" height="404pt" viewBox="-58 0 404 404.54235" width="404pt" xmlns="http://www.w3.org/2000/svg"><path d="m277.527344 0h-267.257813c-5.519531 0-10 4.476562-10 10v374.527344c-.007812 7.503906 4.183594 14.378906 10.855469 17.808594 6.675781 3.425781 14.707031 2.828124 20.796875-1.550782l111.976563-80.269531 111.980468 80.265625c6.09375 4.371094 14.117188 4.964844 20.789063 1.539062 6.667969-3.425781 10.863281-10.296874 10.863281-17.792968v-374.527344c0-5.523438-4.480469-10-10.003906-10zm-10 384.523438-117.796875-84.441407c-3.484375-2.496093-8.171875-2.496093-11.652344 0l-117.800781 84.445313v-364.527344h247.25zm0 0"/></svg>
        <svg *ngIf="isBookmarked" height="404pt" viewBox="-58 0 404 404.54135" width="404pt" xmlns="http://www.w3.org/2000/svg"><path d="m277.527344 0h-267.257813c-5.523437 0-10 4.476562-10 10v374.527344c-.011719 7.503906 4.183594 14.378906 10.855469 17.804687 6.675781 3.429688 14.707031 2.832031 20.796875-1.550781l111.976563-80.265625 111.976562 80.269531c6.097656 4.367188 14.121094 4.960938 20.792969 1.535156 6.667969-3.425781 10.863281-10.292968 10.863281-17.792968v-374.527344c0-5.523438-4.480469-10-10.003906-10zm0 0"/></svg>
      </a>
    </div>
  </div>
  <div
    class="main-note-view__other-tags"
    *ngIf="note.pinned || note.state === 'HIDDEN' || fileAudioIncluded || annotationAllowed || note.price === 0">
    <span class="main-note-view__other-tags__tag tag--free-note" *ngIf="note.price === 0">free note</span>
    <span class="main-note-view__other-tags__tag tag--draft" *ngIf="note.state === 'HIDDEN'">draft</span>
    <span class="main-note-view__other-tags__tag" *ngIf="note.pinned">pinned</span>
    <span class="main-note-view__other-tags__tag tag--audio" *ngIf="fileAudioIncluded">
      <fa-icon [icon]="['fas', 'volume-up']"></fa-icon>
      Audio file included
    </span>
    <span class="main-note-view__other-tags__tag tag--annotate" *ngIf="annotationAllowed">Annotate</span>
  </div>
  <threads *ngIf="isLoggedIn" [note]="note"></threads>
  <section class="main-note-view__content">
    <content-blur-loader *ngIf="loadingContent"></content-blur-loader>
    <div
      *ngIf="!loadingContent"
      class="main-note-view__content__current">
        <!-- <img-lazy-loading
          class="main-note-view__content__current__thumbnail-img"
          *ngIf="note && note.thumbnails && note.thumbnailImage"
          [mainThumb]="note.thumbnailImage"
          [thumbs]="note.thumbnails"
          [title]="'Read more about ' + note.name"></img-lazy-loading> -->
        <div
          class="main-note-view__content__current__wrapper"
          *ngIf="!loadingContent && noteNeedsPayment && note.leadContent && (!isStreamFree || !isNoteFree)"
          [innerHTML]="note.leadContent"></div>
        <div class="main-note-view__content__current__wrapper paywall"
          *ngIf="!loadingContent && (isStreamFree || isNoteFree || isUserAdmin || !noteNeedsPayment)"
          observeElement
          (elementChanged)="premiumContentLoaded()"
          #premiumContentWrapper
          annotations
          [imageCaptions]="!loadingContent && (isLoggedIn || isNoteFree) && !noteNeedsPayment && note.premiumContent | safeHtml"
          [imageLinks]="!loadingContent && (isLoggedIn || isNoteFree) && !noteNeedsPayment && note.premiumContent | safeHtml"
          (statusChange)="annotationStatusChange($event)"
          (errorMessage)="errorMessage($event.title, $event.message)"
          [allowAnnotations]="annotationAllowed"
          [note]="note"
          [innerHTML]="note.premiumContent | safeHtml"></div>
        <audio-player
          *ngIf="!noteNeedsPayment && isLoggedIn && note?.premMedia | mediaFileFilter: ['audio', 'return-exist']"
          class="mt-20 d-block clear"
          [file]="note.premMedia | mediaFileFilter: ['audio', 'return-file']"
          [poster]="note?.thumbnailImage || '/assets/icons/apple-touch-icon-ipad-retina-152x152.png'"></audio-player>
    </div>
  </section>
  <section
    class="main-note-view__other"
    *ngIf="!noteNeedsPayment && isLoggedIn">
      <a (click)="toggleComments()"
        title="Toggle comments"
        *ngIf="enabledComments"
        class="main-note-view__other__comments"
        [ngClass]="{ 'extend' : extendComments, 'loading' : loadingNoteComments }">Comments
          <fa-icon *ngIf="loadingNoteComments" [icon]="['fas', 'sync']" [spin]="true"></fa-icon>
          <span *ngIf="!loadingNoteComments">({{ note.comments ? (note.comments.length > 99) ? '100+' : (note.comments.length) : 0 }})</span>
      </a>
      <div class="main-note-view__other__ratings">
        <span class="main-note-view__other__ratings__label" (click)="openRateNoteModal()">Rate Note&nbsp;</span>
        <ngb-rating [(rate)]="note.rating" (click)="handleRateChange()" (rateChange)="onRateChange($event)" [readonly]="false" max="5" *ngIf="!noteNeedsPayment">
          <ng-template let-fill="fill" let-index="index">
            <span class="star" [class.filled]="fill === 100">&#9733;</span>
          </ng-template>
        </ngb-rating>
      </div>
      <div class="main-note-view__other__report" (click)="openNoteReportModal()">
        <fa-icon [icon]="['fas', 'exclamation-triangle']"></fa-icon>
        <span class="main-note-view__other__report__label">Report Note</span>
      </div>
  </section>
  <section
    class="main-note-view__subscribers"
    [hidden]="isNoteFree || isStreamFree || !noteNeedsPayment">
    <h5>Want to read more?</h5>
    <div>
      <button
        (click)="openSubscribePlansModal()"
        *ngIf="isLoggedInRequirePaymentNoteNotFree && (isStreamOpenCommunityAndUserIsMemeber || note.stream.kind !== streamKind.OpenCommunity)"
        [ngClass]="{'min-price-label': subscriptionPlansPrice && subscriptionPlansPrice['min']}"
        class="subscribe--button">
        {{isStreamFree ? 'Subscribe to this stream for free' : 'Subscribe to this stream'}}
          <span *ngIf="subscriptionPlansPrice && subscriptionPlansPrice['min']"
                class="subs-min-price">from {{subscriptionPlansPrice['min'] / 100 | currency:'USD':'symbol':'1.2-2'}}{{notUSCitizen ? ' and free for new users' : ''}}</span>
      </button>
      <button
        (click)="joinOpenCommunity()"
        *ngIf="isLoggedInRequirePaymentNoteNotFree && note.stream.kind === streamKind.OpenCommunity && !userIsAlreadyACommunityMember"
        [ngClass]="{'min-price-label': subscriptionPlansPrice && subscriptionPlansPrice['min']}"
        class="subscribe--button notd__p-l-10 notd__p-r-10">
          Join Community Stream
      </button>
    </div>
    <div
      class="main-note-view__subscribers__free"
      *ngIf="isNotLoggedInRequirePaymentNoteNotFree">
      <button
        (click)="loadingLoginPage = true"
        transact-auth
        [ngClass]="{'button-spinner' : loadingLoginPage}"
        class="subscribe--button free-for-users-label">
        {{isStreamFree ? 'Login or sign-up to subscribe for free' : 'Login or sign-up to subscribe'}}
          <span class="add-info" *ngIf="notUSCitizen">Free for new users who get $3 credit</span></button>
    </div>
    <div
      class="main-note-view__subscribers__free"
      *ngIf="isNotLoggedInNoteIsFree">
      <button
        (click)="loadingLoginPage = true"
        transact-auth
        [ngClass]="{'button-spinner' : loadingLoginPage}"
        class="subscribe--button free-for-users-label">
          Register or login to view this note for free
        </button>
    </div>
  </section>
  <section class="main-note-view__comments_wrapper" *ngIf="!noteNeedsPayment && note.state === 'PUBLIC' && extendComments && enabledComments && isLoggedIn">
    <app-comment *ngFor="let comment of note?.comments" (refreshComments)="refreshComments()" [comment]="comment" level="0"></app-comment>
    <div class="main-note-view__comments_wrapper__comments">
      <textarea
        *ngIf="!commentError.show"
        class="main-note-view__comments_wrapper__comments__textarea"
        placeholder="Your Comment"
        [ngClass]="{ 'extend' : extendCommentSpace }"
        [(ngModel)]="newComment"
        (keydown)="extendCommentArea()"></textarea>
    </div>
    <button
      *ngIf="!commentError.show"
      (click)="addNewComment()"
      [disabled]="!newComment || newComment.length < 4" class="notd__button--v2 submit--button">Submit Comment</button>
    <div
      *ngIf="commentError.show"
      class="main-note-view__comments_wrapper__error">
      <a
        (click)="closeErrorMessage()"
        class="main-note-view__comments_wrapper__error__close"
        title="Close message">
        <svg enable-background="new 0 0 413.348 413.348" height="512" viewBox="0 0 413.348 413.348" width="512" xmlns="http://www.w3.org/2000/svg"><path d="m413.348 24.354-24.354-24.354-182.32 182.32-182.32-182.32-24.354 24.354 182.32 182.32-182.32 182.32 24.354 24.354 182.32-182.32 182.32 182.32 24.354-24.354-182.32-182.32z"/></svg>
      </a>
      <svg class="main-note-view__comments_wrapper__error__icon" fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="M12.8455 5.21137C12.4531 4.59003 11.5469 4.59003 11.1545 5.21137L2.78316 18.466C2.36261 19.1319 2.84109 20 3.62865 20H20.3713C21.1589 20 21.6374 19.1319 21.2168 18.466L12.8455 5.21137ZM9.46353 4.14338C10.6408 2.27935 13.3592 2.27936 14.5365 4.14339L22.9078 17.398C24.1695 19.3956 22.734 22 20.3713 22H3.62865C1.26598 22 -0.169465 19.3956 1.09218 17.398L9.46353 4.14338ZM13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17ZM10.6941 10.1644L11.4178 14.5068C11.4652 14.7914 11.7115 15 12 15C12.2885 15 12.5348 14.7914 12.5822 14.5068L13.3059 10.1644C13.4075 9.55487 12.9375 9 12.3195 9H11.6805C11.0625 9 10.5925 9.55487 10.6941 10.1644Z" fill="#222222" fill-rule="evenodd"/></svg>
      <p>
        {{commentError.message}}
      </p>
    </div>
  </section>
</section>

<subscribe-plans
  *ngIf="isStreamOpenCommunityAndUserIsMemeber || (note.stream && note.stream.kind !== streamKind.OpenCommunity)"
  [isLoggedIn]="isLoggedIn"
  [isStreamFree]="isStreamFree"
  [checkSubStatus]="true"
  [streamId]="note.channelId"></subscribe-plans>

  <ng-template #noteReportModal let-c="close" let-d="dismiss">
    <a (click)="d('Cross click')" data-cy="close-modal" class="note-report-modal__close-btn" title="Close Note Report Modal">
        <svg id="Capa_1" enable-background="new 0 0 413.348 413.348" height="512" viewBox="0 0 413.348 413.348" width="512" xmlns="http://www.w3.org/2000/svg"><path d="m413.348 24.354-24.354-24.354-182.32 182.32-182.32-182.32-24.354 24.354 182.32 182.32-182.32 182.32 24.354 24.354 182.32-182.32 182.32 182.32 24.354-24.354-182.32-182.32z"/></svg>
    </a>
    <h2 class="note-report-modal__title">
        Report This Note
    </h2>
    <section class="note-report-modal__content">
      <form
          class="notd__form" [formGroup]="noteReportForm">
          <section class="note-report-modal__content__form">
            <div class="note-report-modal__content__form__input-wrapper">
                <label>Report type:</label>
                <notd-dropdown
                    [buttonLabel]="'Select your report type'"
                    [objectConvert]="{label: 'value', selected: 'selected'}"
                    (elementSelected)="selectNoteReportType($event)"
                    [options]="reportFlagsList">
                </notd-dropdown>
                <span
                    class="note-report-modal__content__form__input-wrapper__error"
                    *ngIf="reportNoteFormSubmited && noteReportForm.get('reason').hasError('required')">
                        <svg enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="256" x2="256" y1="512" y2="0"><stop offset="0" stop-color="#fd3a84"/><stop offset="1" stop-color="#ffa68d"/></linearGradient><linearGradient id="lg1"><stop offset="0" stop-color="#ffc2cc"/><stop offset="1" stop-color="#fff2f4"/></linearGradient><linearGradient id="SVGID_2_" gradientUnits="userSpaceOnUse" x1="256" x2="256" xlink:href="#lg1" y1="301" y2="91"/><linearGradient id="SVGID_3_" gradientUnits="userSpaceOnUse" x1="256" x2="256" xlink:href="#lg1" y1="421" y2="331"/><g><g><path d="m355.826 512h-199.651c-3.979 0-7.794-1.58-10.606-4.394l-141.175-141.174c-2.814-2.813-4.394-6.628-4.394-10.606v-199.652c0-3.978 1.58-7.793 4.394-10.606l141.174-141.174c2.813-2.814 6.628-4.394 10.607-4.394h199.651c3.979 0 7.794 1.581 10.606 4.394l141.174 141.174c2.813 2.813 4.394 6.628 4.394 10.606v199.651c0 3.978-1.58 7.793-4.394 10.606l-141.173 141.175c-2.813 2.813-6.628 4.394-10.607 4.394z" fill="url(#SVGID_1_)"/></g><g id="Error"><g><path d="m256 301c-24.813 0-45-20.187-45-45v-120c0-24.813 20.187-45 45-45s45 20.187 45 45v120c0 24.813-20.187 45-45 45z" fill="url(#SVGID_2_)"/></g><g><path d="m256 421c-24.813 0-45-20.187-45-45s20.187-45 45-45 45 20.187 45 45-20.187 45-45 45z" fill="url(#SVGID_3_)"/></g></g></g></svg>
                        Please select your raport type.
                </span>
            </div>
        </section>
          <section class="note-report-modal__content__form">
            <div class="note-report-modal__content__form__input-wrapper">
                <label>Report comment:</label>
                <textarea
                    class="note-report-modal__content__form__input-wrapper__textarea notd__textarea"
                    formControlName="comment"
                    placeholder="Your report"></textarea>
            </div>
        </section>
      </form>
      <div class="note-report-modal__content__buttons">
          <button
              type="button"
              class="notd__button--v2 button--black" (click)="sendNoteReport();">Send</button>
          <button
              type="button"
              class="notd__button--v2 button--black" (click)="d('Cross click');">Close</button>
      </div>
  </section>
</ng-template>
